/* Delegation supports Shopify section reloads without duplicate listeners. */
(() => {
  if (window.beardbuxExplorerReady) return;
  window.beardbuxExplorerReady = true;
  document.addEventListener('click', (event) => {
    const choice = event.target.closest('.bbx-reward-choice');
    if (!choice) return;
    const root = choice.closest('.bbx');
    root.querySelectorAll('.bbx-reward-choice').forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
    root.querySelector('[data-reward-value]').textContent = '$' + choice.dataset.value;
    root.querySelector('[data-reward-points]').textContent = choice.dataset.points + ' Beardbux';
  });
})();
